import { useCampaignCapabilitiesStore, useReportExportSSE } from '@discovr/features';
import { notifyReportExportEvent } from './reportExportNotifications';

/** Headless: toasts the requester's export events wherever they are on the campaign page.
 *  Self-gates on the admin lane, like the import popup — the brand app never has exports. */
export function ReportExportNotifier() {
  const isAdminLane = useCampaignCapabilitiesStore((s) => s.lane === 'admin');
  useReportExportSSE({ enabled: isAdminLane, onEvent: notifyReportExportEvent });
  return null;
}
